var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.333 4.945v1.833H3.111c-.675 0-1.222.548-1.222 1.223v5.5c0 .675.547 1.222 1.222 1.222h9.778c.675 0 1.222-.547 1.222-1.223V8c0-.674-.547-1.222-1.222-1.222H5.556V4.945a2.444 2.444 0 0 1 4.888 0v1.827h1.223V4.945a3.667 3.667 0 0 0-7.334 0zm-1.222 8.556V8h9.778v5.5H3.11z",
    fill: "#007FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.96cf9ac1a845e5a0ecd1ab88a44f2f07.svg";
export { ForwardRef as ReactComponent };